const host = window.location.host;

const testUrl = 'https://web-api.b.islide.cc';
const releaseUrl = 'https://web-api.islide.cc';
const testCodeUrl='https://api.b.islide.cc/v6';
const codeUrl='https://api.islide.cc/v6';
const turnTestUrl='https://store.b.islide.cc';
const turnUrl='https://www.islide.cc'


let baseUrl = '';
let baseCodeUrl='';
let baseTurnUrl='';

if (host === 'web.islide.cc') {
  baseUrl = releaseUrl;
  baseCodeUrl = codeUrl;
  baseTurnUrl = turnUrl;
} else {
  baseUrl = testUrl;
  baseCodeUrl = testCodeUrl;
  baseTurnUrl = turnTestUrl;
}

export {baseTurnUrl};

export async function register(email: string,trialId:string,state:string,inviterId?:string,lang?: string) {
  let result = await fetch(`${baseUrl}/trial/register/user?email=${email}&trialId=${trialId}&inviterId=${inviterId}&state=${state}`, {
    method: 'post',
    headers: {
      'Accept-Language': lang ? lang : 'zh-Hans'
    }
  });
  return result.json();
}

export async function fackbookLink(trialId:string,userId:string) {
  let result = await fetch(`${baseUrl}/facebook/share/link?trialId=${trialId}&userId=${userId}`, {
    method: 'get',
  });
  return result.json();
}
export async function getCode() {
  let result = await fetch(`${baseCodeUrl}/embed/user/code`, {
    method: 'get',
    headers:{
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('token') as string
    },
  });
  return result.json();
}
export async function recordShare(contentId:any,params:any) {
  let result = await fetch(`${baseUrl}/trial/content/${contentId}/share`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    body:JSON.stringify(params)
  });
  return result.json();
}
export async function trialDetail(params:any,inviteId?:any,state?:any) {
  let queryStr=inviteId?`?inviterId=${inviteId}`:'';
      queryStr=queryStr?queryStr+`&state=${state}`:`?state=${state}`
  let result = await fetch(`${baseUrl}/trial/${params}/detail${queryStr}`, {
    method: 'get',
  });
  return result.json();
}
export async function getShareDetail(params:any) {
  let url = encodeURIComponent(`${params}`)
  let result = await fetch(`${baseUrl}/trial/jssdk/config?url=${url}`, {
    method: 'get',
  });
  return result.json();
}
export async function contentShareDetail(contentId:any) {
  let result = await fetch(`${baseUrl}/trial/content/${contentId}`, {
    method: 'get',
  });
  return result.json();
}
export async function contentShareItems(contentId:any,inviteId?:any,source?:any) {
  let queryStr='?recordShare=true'
  let inviteStr=inviteId?`&inviterId=${inviteId}`:''
  let sourceStr=source?`&source=${source}`:''
  queryStr=queryStr+inviteStr+sourceStr
  let result = await fetch(`${baseUrl}/trial/content/${contentId}/share${queryStr}`, {
    method: 'get',
  });
  return result.json();
}
export async function getPhoneCode(params:any,trialId:any,ticket:any,randstr:any,state:any) {
  let url = encodeURIComponent(`${params}`)
  let result = await fetch(`${baseUrl}/trial/register/phone/code?phone=${url}&trialId=${trialId}&ticket=${ticket}&randstr=${randstr}&state=${state}`, {
    method: 'get',
  });
  return result.json();
}
export async function getNewPhoneCode(params:any,trialId:any,ticket:any,randstr:any,state:any) {
  let url = encodeURIComponent(`${params}`)
  let result = await fetch(`${baseUrl}/trial/login/phone/code?phone=${url}&trialId=${trialId}&ticket=${ticket}&randstr=${randstr}&state=${state}`, {
    method: 'get',
  });
  return result.json();
}
export async function phoneNewRegister(phone: string,trialId:string,code:string,state:string,inviterId?:string,lang?: string) {
  let result = await fetch(`${baseUrl}/trial/login/phone?phone=${encodeURIComponent(phone)}&code=${code}&trialId=${trialId}&inviterId=${inviterId}&state=${state}`, {
    method: 'post',
    headers: {
      'Accept-Language': lang ? lang : 'zh-Hans'
    }
  });
  return result.json();
}
export async function phoneRegister(phone: string,trialId:string,code:string,state:string,inviterId?:string,lang?: string) {
  let result = await fetch(`${baseUrl}/trial/register/phone?phone=${encodeURIComponent(phone)}&code=${code}&trialId=${trialId}&inviterId=${inviterId}&state=${state}`, {
    method: 'post',
    headers: {
      'Accept-Language': lang ? lang : 'zh-Hans'
    }
  });
  return result.json();
}
